import {colors} from 'lib/ui/theme'
import React from 'react'
import styled from 'styled-components'

interface AddSiblingButtonProps {
  onClick: (e: React.MouseEvent) => void
  className?: string
  color: string
}

export default function AddSiblingButton(props: AddSiblingButtonProps) {
  const {onClick, className, color = colors.primary} = props

  return (
    <Box onClick={onClick} className={className}>
      <Button color={color}>Add Block</Button>
    </Box>
  )
}

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
`

const Button = styled.button<{color: string}>`
  color: white;
  border: none;
  cursor: pointer;
  background: ${(props) => props.color};
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
`
